import { useAppSelector } from "../../../hooks/store-hooks"
import { PreLoaderStylesProvider } from "./styles/PreLoaderStylesProvider"

export const PreLoader = () => {
    const loadings = useAppSelector((state) => state.ui.loadings)
    return (
        <>
            <PreLoaderStylesProvider>
                <div>
                    <div></div>
                    <span>
                        {
                            loadings.length > 0 && loadings[0].message
                        }
                    </span>
                </div>
            </PreLoaderStylesProvider>
        </>
    )
}
